import InputComponent from "./InputComponent";

export default InputComponent;
